import React, { FunctionComponent } from "react";
import styles from "./ProfileRecentFeedbacks.module.scss";
import moment from "moment";
import { Link } from "react-router-dom";

const ProfileRecentFeedbacks: FunctionComponent<{ recentFeedbacks: any }> = ({
  recentFeedbacks,
}) => {
  return (
    <div className={styles.profileRecentFeedbacks_panel}>
      <h4>Recent Feedbacks</h4>
      {recentFeedbacks?.map(
        ({ content, solution, submittedAt, parentId, id }: any) => (
          <div className={styles.profileRecentFeedbacks_panel_card} key={id}>
            <div className={styles.profileRecentFeedbacks_panel_card_time}>
              {moment(submittedAt).toNow()}
            </div>
            <div className={styles.profileRecentFeedbacks_panel_card_feedback}>
              {content.length <= 150 ? content : `${content.slice(0, 150)}...`}
            </div>
            {solution && (
              <div
                className={styles.profileRecentFeedbacks_panel_card_solution}
              >
                on{" "}
                <Link
                  to={`/solutions/${parentId}`}
                  className={
                    styles.profileRecentFeedbacks_panel_card_solution_title
                  }
                >
                  {solution.title}
                </Link>
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default ProfileRecentFeedbacks;
